import ValidationInterface from "@/plans/common/validation-interface";
import {
  bizPlusCategories, eduPlusCategories, meetingCategories, proPlusCategories,
  SDKCategories,
  SDKUCCategories,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [this.current(bizPlusCategories).require(["ZVP", "ZVC"], { billingCycleEqual: true })];
  }

  async conflicts() {
    return [
      ...this.current(bizPlusCategories).conflict(
        [...meetingCategories.filter(c => c !== "biz"), ...proPlusCategories, ...eduPlusCategories, ...SDKCategories, ...SDKUCCategories]),
    ];
  }
}
